import type {
  ArtApiSortingEnum,
  GenreFullSerializer,
  IApiResponse,
  GenreDetailSerializer,
  FacetedArtsDataSerializer,
  FacetedArtsResponseSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";

import type { IArtsFacetsRequest } from "../../types/api";
import { TagsType } from "../constants";

interface IAllGenresRequestParams {
  subgenre_depth?: number;
  art_group?: 0 | 1 | 2;
  only_root?: boolean;
}

interface IGenreRequestParams {
  genre_id_or_slug: string;
  is_redirect_by_id?: boolean;
}
export interface IRootArtsFacetsRequest extends IArtsFacetsRequest {
  only_drafts_full_free?: boolean;
  collection_id?: number;
  tag_ids?: number[];
  o?: `${ArtApiSortingEnum}`;
  show_unavailable?: boolean;
}

export interface IGenreArtsFacetsRequest extends IRootArtsFacetsRequest {
  genre_id: number;
}

export const genresApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    getAllGenres: build.query<GenreFullSerializer[], IAllGenresRequestParams>({
      query: params => ({
        url: "/foundation/api/genres",
        params,
        headers: {
          "accept-version": "2",
        },
      }),
      transformResponse: (response: IApiResponse<GenreFullSerializer[]>) => {
        return response.payload.data;
      },
    }),
    getGenreData: build.query<GenreDetailSerializer, IGenreRequestParams>({
      query: ({ genre_id_or_slug, ...params }) => ({
        url: `/foundation/api/genres/${genre_id_or_slug}`,
        params: {
          is_redirect_by_id: true,
          ...params,
        },
        headers: {
          "accept-version": "2",
        },
      }),
      transformResponse: (response: IApiResponse<GenreDetailSerializer[]>) => {
        return response.payload.data[0];
      },
    }),
    getGenreFacets: build.query<
      FacetedArtsDataSerializer,
      IGenreArtsFacetsRequest
    >({
      query: ({ genre_id, ...params }) => ({
        url: `/foundation/api/genres/${genre_id}/arts/facets`,
        params,
        headers: {
          "accept-version": "2",
        },
      }),
      transformResponse: (response: FacetedArtsResponseSerializer) => {
        return response.payload;
      },
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
    getRootFacets: build.query<
      FacetedArtsDataSerializer,
      IRootArtsFacetsRequest
    >({
      query: params => ({
        url: `/foundation/api/arts/facets`,
        params,
        headers: {
          "accept-version": "2",
        },
      }),
      transformResponse: (response: FacetedArtsResponseSerializer) => {
        return response.payload;
      },
      providesTags: result =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: TagsType.ART_SHORT_LIST as const,
                id,
              })),
              TagsType.ART_SHORT_LIST,
            ]
          : [TagsType.ART_SHORT_LIST],
    }),
  }),
});
